import { Injectable } from '@angular/core';

export class Configuration {
  constructor(
    public bootstrap_url: string,
    public client_id: string,
    public account: string,
    public force_local?: boolean
  ) {  }
}

export class Urls {
  constructor(
    public canonical?: string,
    public websocket?: string,
    public proxy?: string,
  ) {  }
}


export class Authentication {
  constructor(
    public token?: string,
    public jwt?: string,
    public oauth?: string,
    public username?: string
  ) { }
}
